import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { useAppSelector } from 'flex/utils';

type Props = {
    screen?: string,
};

const RestrictedMsgTooltip: React.FC<Props> = ({ screen = '利用者'}) => {
    const isControllableUser = useAppSelector((state) => state.isControllableUser.payload);
    const tooltipTitle = isControllableUser
        ? '全体管理者で管理されています。設定タブから変更できます。'
        : '全体管理者で管理されています。';

    return (
        <div className='flex items-center'>
            <span style={{ color: 'red' }}>{screen}の登録・編集・削除が制限されています</span>
            <Tooltip title={tooltipTitle}>
                <InfoCircleOutlined style={{ color: 'red' }} className='icon-l' />
            </Tooltip>
        </div>
    );
};

export default RestrictedMsgTooltip;
